import React from 'react';
import { Translate } from 'react-redux-i18n';
import TropheIcon from './TropheIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EmptyDashboard() {
  return /*#__PURE__*/_jsx("div", {
    className: "card",
    children: /*#__PURE__*/_jsxs("div", {
      className: "col-12 inline-container column center mt-4 justify-content-center",
      children: [/*#__PURE__*/_jsx(TropheIcon, {}), /*#__PURE__*/_jsx("strong", {
        style: {
          fontSize: '30px'
        },
        children: /*#__PURE__*/_jsx(Translate, {
          value: "dashboard.empty.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: "dashboard.empty.message"
        })
      })]
    })
  });
}
export default EmptyDashboard;